import Vue from 'vue';
import App from './App';
import BootstrapVue from 'bootstrap-vue';
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';
import router from './router';
import {ServerTable, ClientTable, Event} from 'vue-tables-2';
import vueHeadful from 'vue-headful';
import vue2Dropzone from 'vue2-dropzone'
import { VueEditor } from "vue2-editor";
import vSelect from 'vue-select';
import Multiselect  from 'vue-multiselect'; //https://vue-multiselect.js.org/
import vueMultiSelect  from 'vue-multi-select'; //https://vue-multi-select.tuturu.io/
//import vueHeadful from 'vue-simple-headful';
import * as uiv from 'uiv';
import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more'
import loadExporting from 'highcharts/modules/exporting';
import loadSolidGauge from 'highcharts/modules/solid-gauge';
import VueCropper from 'vue-cropperjs';
import VueRecaptcha from 'vue-recaptcha';
import VueSignaturePad from 'vue-signature-pad';
import VClamp from 'vue-clamp';
import _ from 'lodash';

//NOT IE11 Compatible (not ES6 compatible)
//import VuejsClipper from 'vuejs-clipper';

//Store
import store from './store';
import globals from './globals'
import Popper from 'popper.js'
import Api from './helpers/Api';
import toastr from './helpers/Toastr';
import datePicker from 'vue-bootstrap-datetimepicker';

import AffixNavHelper from './components/AffixNavHelper';
import BehaviorModal from './components/BehaviorModal';
import BidItem from './components/subcontractors/BidItem';
import BidList from './components/subcontractors/BidList';
import BidModal from './components/subcontractors/BidModal';
import ClientList from './components/clients/ClientList';
import ClientSubApprovals from './components/ClientSubApprovals';
import CommentList from './components/CommentList';
import ConditionModal from './components/ConditionModal';
import CorrectiveActionList from './components/actions/CorrectiveActionList';
import CorrectiveActionItem from './components/actions/CorrectiveActionItem';
import CorrectiveActionModal from './components/actions/CorrectiveActionModal';
import CorrectiveActionTableList from './components/actions/CorrectiveActionTableList';
import CorrectiveActionViewModal from './components/actions/CorrectiveActionViewModal';
import CustomFieldBuilder from './components/custom-fields/Build';
import CustomFieldPrint from './components/custom-fields/Print';
import CustomFieldsEdit from './components/custom-fields/FieldsEdit';
import CustomFieldsForm from './components/custom-fields/FieldsForm';
import CustomFieldsView from './components/custom-fields/View';
import CustomFieldTableDisplay from './components/employees/CustomFieldTableDisplay';
import ActionAssignees from './components/actions/ActionAssignees';
import CABreadCrums from './components/actions/BreadCrumbs';
import DateRangeSelector from './components/DateRangeSelector';
import DisciplinaryList from './components/employees/DisciplinaryList';
import DisciplinaryPrevious from './components/employees/DisciplinaryPrevious';
import DisciplinaryEditModal from './components/employees/DisciplinaryEditModal';
import DriveAssetList from './components/drive/AssetList';
import FormSectionModal from './components/inspections/FormSectionModal';
import FormElementModal from './components/inspections/FormElementModal';
import HazardModal from './components/HazardModal';
import IncidentList from './components/IncidentList';
import IncidentName from './components/IncidentName';
import IncidentDaysAway from './components/incidents/DaysAway';
import InlineEdit from './components/InlineEdit';
import InspectionList from './components/inspections/InspectionList';
import InspectionGoalList from './components/inspections/GoalList';
import InspectionName from './components/inspections/InspectionName';
import InspectionScore from './components/inspections/InspectionScore';
import InspectionSelect from './components/inspections/InspectionSelect';
import InspectionAssessment from './components/inspections/InspectionViewAssessment';
import InspectionAssessmentList from './components/inspections/InspectionViewAssessmentList';
import JobsiteInsuranceList from './components/JobsiteInsuranceList';
import ObservationList from './components/observations/List';
import TableFilters from './components/TableFilters';
import TableFiltersV2 from './components/TableFiltersV2';
import EmailAlertList from './components/email-alerts/List';
import EmailAlertRecipients from './components/alerts/Recipients';
import EmployeeList from './components/employees/EmployeeList';
import EmployeeSelect from './components/employees/EmployeeSelect';
import EmployeeForm from './components/employees/EmployeeForm';
import EmployeeModal from './components/employees/EmployeeModal';
import EmployeeRecognitionList from './components/employees/EmployeeRecognitionList';
import CheckedEquipmentList from './components/equipment/CheckedEquipmentList';
import EquipmentList from './components/equipment/EquipmentList';
import EquipmentTrackingList from './components/equipment/EquipmentTrackingList';
import EquipmentDateList from './components/equipment/EquipmentDateList';
import EquipmentSelect from './components/equipment/EquipmentSelect';
import SubDesignationModal from './components/subcontractors/SubDesignationModal';
import SubDesignationCreateModal from './components/subcontractors/SubDesignationCreateModal';
import SubDesignationList from './components/subcontractors/SubDesignationList';
import SubRatingList from './components/subcontractors/SubRatingList';
import SubRatingForm from './components/subcontractors/SubRatingForm';
import HistoryList from './components/HistoryList';
import JobsiteList from './components/JobsiteList';
import JobsiteName from './components/JobsiteName';
import JobsiteSelect from './components/JobsiteSelect';
import JobsiteModal from './components/JobsiteModal';
import JobsiteCheckIns from './components/JobsiteCheckIns';
import JsaList from './components/JsaList';
import JsaEmployeeList from './components/JsaEmployeeList';
import JsaJobStep from './components/JsaJobStep';
import JsaJobStepHazard from './components/JsaJobStepHazard';
import JsaControlsMselect from './components/JsaControlsMselect';
import SubLicenseList from './components/subcontractors/SubLicenseList';
import SubLicenseModal from './components/subcontractors/SubLicenseModal';
import MetricModal from './components/clients/MetricModal';
import InspectionResultModal from './components/inspections/InspectionResultModal';
import QrCode from './components/QrCode';
import SubOshaYearModal from './components/subcontractors/SubOshaYearModal';
import OshaCitationList from './components/subcontractors/OshaCitationList';
import OshaCitationModal from './components/subcontractors/OshaCitationModal';
import OneClickLogin from './components/OneClickLogin';
import ReferenceModal from './components/subcontractors/ReferenceModal';
import RootCauseIndex from './components/settings/RootCauseIndex';
import SafetyDataList from './components/safety-data-sheets/List';
import SafetyDataSelect from './components/safety-data-sheets/Select';
import SafetyMeetingList from './components/safety-meetings/List';
import SubApprovalsList from './components/SubApprovalsList';
import SubOshaYearList from './components/subcontractors/SubOshaYearList';
import SubStatusModal from './components/subcontractors/StatusModal';
import SubSectionStatusModal from './components/subcontractors/SectionStatusModal';
import SubApprovalModal from './components/clients/SubApprovalModal';
import SubcontractorList from './components/subcontractors/SubcontractorList';
import SubcontractorModal from './components/subcontractors/Modal';
import SubcontractorSelect from './components/SubcontractorSelect';
import ReferenceList from './components/subcontractors/ReferenceList';
import OshaSubList from './components/subcontractors/OshaSubList';
import TrainingCourseList from './components/training-courses/List';
import EmployeeTrainingList from './components/training-courses/EmployeeList';
import EmployeeName from './components/EmployeeName';
import RoleSelect from './components/RoleSelect';
import UserList from './components/UserList';
import UserModal from './components/UserModal';
import UserName from './components/UserName';
import UserSelect from './components/UserSelect';
import UserFilters from './components/UserFilters';
import TradeList from './components/settings/TradeList';
import FieldTrainingList from './components/settings/FieldTrainingList';
import WorkAreaList from './components/settings/WorkAreaList';
import RegistrationList from './components/settings/RegistrationList';
import SavedFilterTitle from './components/SavedFilterTitle';

//FILE Components
import FileList from './components/files/List';
import FileTable from './components/files/Table';
import FilePreview from './components/files/Preview';
import FileUploader from './components/files/Uploader';

//Other Stuff
import HSEList from './components/HSEList';
import EquipmentFileList from './components/EquipmentFileList';
import StatusHistory from './components/StatusHistory';

//REPORTS
import ReportIncidentTotalsDisplay from './components/reports/incidents/TotalsDisplay';

import DashSafetyMeetingList from './components/dashboard/SafetyMeetingList';
import DashDisciplinaryList from './components/dashboard/DisciplinaryList';
import DashEmployeeRecognitionList from './components/dashboard/EmployeeRecognitionList';
import DashSubcontractorList from './components/dashboard/SubcontractorList';
import DashNonCompliantList from './components/dashboard/NonCompliantList';
import DashCorrectiveActionList from './components/dashboard/CorrectiveActionList';
import DashIncidentList from './components/dashboard/IncidentList';
import DashInspectionList from './components/dashboard/InspectionList';
import DashInspectionScoreList from './components/dashboard/InspectionScoreList';
import DashIncidentEmployeeList from './components/dashboard/IncidentEmployeeList';
import DashIncidentJobsiteList from './components/dashboard/IncidentJobsiteList';
import DashIncidentTypeList from './components/dashboard/IncidentTypeList';
import DashOshaNewsList from './components/dashboard/OshaNewsList';
import DashTotal from './components/dashboard/Total';

import DivisionList from './components/settings/DivisionList';
import HseTypeList from './components/settings/HseTypeList';
import LicenseList from './components/settings/LicenseList';
import DesignationList from './components/settings/DesignationList';
import FacilityTypeList from './components/settings/FacilityTypeList';
import IncidentTypeList from './components/settings/IncidentTypeList';
import InjuryTypeList from './components/settings/InjuryTypeList';
import SafetySettingsList from './components/settings/SafetySettingsList';
import MajorBodyPartsList from './components/settings/MajorBodyPartsList';
import SpecificBodyPartsList from './components/settings/SpecificBodyPartsList';
import RecognitionList from './components/settings/RecognitionList';
import NonCompliantList from './components/reports/NonCompliantList';
import EquipmentSectionsBuilder from './components/equipment/EditSections';
import EquipmentSectionsView from './components/equipment/ViewSections';
import IncidentSectionsBuilder from './components/incidents/EditSections';
import IncidentSectionsView from './components/incidents/ViewSections';
import CovidList from './components/covid/List';
import CovidFields from './components/covid/Fields';
import CovidSectionsView from './components/covid/ViewSections';
import PersonnelEdit from './components/personnel/Edit';
import PersonnelView from './components/personnel/View';
import PersonnelForm from './components/personnel/Form';

//VueTables2 Custom Modules
import customVTFilter from './components/vue-tables-2/CustomGenericFilter';
import customVTColDropdown from './components/vue-tables-2/CustomColumnDropdown';
import customVTTheme from './components/vue-tables-2/VtTheme';

//Setup
var customVTComponents = {
	columnsDropdown: customVTColDropdown
};

//Bootstrap Table
//import 'jquery/dist/jquery.js';
//import 'bootstrap-table/dist/bootstrap-table.js';

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false

Vue.config.productionTip = false

//Set Global Tools
Vue.prototype.$http = Api;
Vue.prototype.$toastr = toastr;
Vue.prototype.__ = str => _.get(window.i18n, str);

Vue.component('v-clamp', VClamp);

Vue.component('dash-safety-meeting-list', DashSafetyMeetingList);
Vue.component('dash-disciplinary-list', DashDisciplinaryList);
Vue.component('dash-employee-recognition-list', DashEmployeeRecognitionList);
Vue.component('dash-subcontractor-list', DashSubcontractorList);
Vue.component('dash-non-compliant-list', DashNonCompliantList);
Vue.component('dash-corrective-action-list', DashCorrectiveActionList);
Vue.component('dash-incident-list', DashIncidentList);
Vue.component('dash-inspection-list', DashInspectionList);
Vue.component('dash-inspection-score-list', DashInspectionScoreList);
Vue.component('dash-incident-employee-list', DashIncidentEmployeeList);
Vue.component('dash-incident-jobsite-list', DashIncidentJobsiteList);
Vue.component('dash-incident-type-list', DashIncidentTypeList);
Vue.component('dash-osha-news-list', DashOshaNewsList);
Vue.component('dashboard-total', DashTotal);

//Global Components
Vue.component('action-assignees', ActionAssignees);
Vue.component('affix-nav-helper', AffixNavHelper);
Vue.component('behavior-modal', BehaviorModal);
Vue.component('bid-item', BidItem);
Vue.component('bid-list', BidList);
Vue.component('bid-modal', BidModal);
Vue.component('client-list', ClientList);
Vue.component('client-subcontractor-approvals', ClientSubApprovals);
Vue.component('comment-list', CommentList);
Vue.component('condition-modal', ConditionModal);
Vue.component('corrective-action-list', CorrectiveActionList);
Vue.component('corrective-action-item', CorrectiveActionItem);
Vue.component('corrective-action-modal', CorrectiveActionModal);
Vue.component('corrective-action-table-list', CorrectiveActionTableList);
Vue.component('corrective-action-view-modal', CorrectiveActionViewModal);
Vue.component('corrective-action-breadcrumbs', CABreadCrums);
Vue.component('covid-list', CovidList);
Vue.component('covid-fields', CovidFields);
Vue.component('covid-sections-view', CovidSectionsView);
Vue.component('custom-field-builder', CustomFieldBuilder);
Vue.component('custom-field-print', CustomFieldPrint);
Vue.component('custom-field-edit', CustomFieldsEdit);
Vue.component('custom-field-form', CustomFieldsForm);
Vue.component('custom-field-view', CustomFieldsView);
Vue.component('custom-field-table-display', CustomFieldTableDisplay);
Vue.component('date-range-selector', DateRangeSelector);
Vue.component('disciplinary-list', DisciplinaryList);
Vue.component('disciplinary-previous', DisciplinaryPrevious);
Vue.component('disciplinary-edit-modal', DisciplinaryEditModal);
Vue.component('division-list', DivisionList);
Vue.component('drive-asset-list', DriveAssetList);
Vue.component('email-alert-list', EmailAlertList);
Vue.component('email-alert-recipients', EmailAlertRecipients);
Vue.component('employee-list', EmployeeList);
Vue.component('employee-name', EmployeeName);
Vue.component('employee-training-list', EmployeeTrainingList);
Vue.component('employee-select', EmployeeSelect);
Vue.component('employee-form', EmployeeForm);
Vue.component('employee-modal', EmployeeModal);
Vue.component('employee-recognition-list', EmployeeRecognitionList);
Vue.component('checked-equipment-list', CheckedEquipmentList);
Vue.component('equipment-list', EquipmentList);
Vue.component('equipment-tracking-list', EquipmentTrackingList);
Vue.component('equipment-date-list', EquipmentDateList);
Vue.component('equipment-select', EquipmentSelect);
Vue.component('equipment-sections-builder', EquipmentSectionsBuilder);
Vue.component('equipment-sections-view', EquipmentSectionsView);
Vue.component('facility-type-list', FacilityTypeList);
Vue.component('file-list', FileList);
Vue.component('file-table', FileTable);
Vue.component('file-preview', FilePreview);
Vue.component('equipment-file-list', EquipmentFileList);
Vue.component('file-uploader', FileUploader);
Vue.component('form-section-modal', FormSectionModal);
Vue.component('form-element-modal', FormElementModal);
Vue.component('hazard-modal', HazardModal);
Vue.component('history-list', HistoryList);
Vue.component('hse-list', HSEList);
Vue.component('hse-type-list', HseTypeList);
Vue.component('jobsite-insurance-list', JobsiteInsuranceList);
Vue.component('license-list', LicenseList);
Vue.component('designation-list', DesignationList);
Vue.component('incident-list', IncidentList);
Vue.component('incident-name', IncidentName);
Vue.component('incident-sections-builder', IncidentSectionsBuilder);
Vue.component('incident-sections-view', IncidentSectionsView);
Vue.component('incident-type-list', IncidentTypeList);
Vue.component('incident-days-away', IncidentDaysAway);
Vue.component('injury-type-list', InjuryTypeList);
Vue.component('inline-edit', InlineEdit);
Vue.component('inspection-list', InspectionList);
Vue.component('inspection-name', InspectionName);
Vue.component('inspection-score', InspectionScore);
Vue.component('inspection-select', InspectionSelect);
Vue.component('inspection-goal-list', InspectionGoalList);
Vue.component('inspection-assessment', InspectionAssessment);
Vue.component('inspection-assessment-list', InspectionAssessmentList);
Vue.component('inspection-result-modal', InspectionResultModal);
Vue.component('non-compliant-list', NonCompliantList);
Vue.component('observation-list', ObservationList);
Vue.component('qr-code', QrCode);
Vue.component('jobsite-list', JobsiteList);
Vue.component('jobsite-name', JobsiteName);
Vue.component('jobsite-select', JobsiteSelect);
Vue.component('jobsite-modal', JobsiteModal);
Vue.component('jobsite-check-ins', JobsiteCheckIns);
Vue.component('jsa-list', JsaList);
Vue.component('jsa-employee-list', JsaEmployeeList);
Vue.component('jsa-job-steps', JsaJobStep);
Vue.component('jsa-job-step-hazard', JsaJobStepHazard);
Vue.component('jsa-controls-mselect', JsaControlsMselect);
Vue.component('sub-license-list', SubLicenseList);
Vue.component('sub-license-modal', SubLicenseModal);
Vue.component('major-body-parts-list', MajorBodyPartsList);
Vue.component('metric-modal', MetricModal);
Vue.component('multi-select', vueMultiSelect);
Vue.component('multiselect', Multiselect);
Vue.component('osha-year-modal', SubOshaYearModal);
Vue.component('osha-citation-modal', OshaCitationModal);
Vue.component('osha-citation-list', OshaCitationList);
Vue.component('one-click-login', OneClickLogin);
Vue.component('personnel-edit', PersonnelEdit);
Vue.component('personnel-form', PersonnelForm);
Vue.component('personnel-view', PersonnelView);
Vue.component('recognition-list', RecognitionList);
Vue.component('references-list', ReferenceList);
Vue.component('reference-modal', ReferenceModal);
Vue.component('role-select', RoleSelect);
Vue.component('root-cause-settings', RootCauseIndex);

//REPORTS
Vue.component('report-incident-totals-display', ReportIncidentTotalsDisplay);

Vue.component('safety-data-sheets-list', SafetyDataList);
Vue.component('safety-data-sheets-select', SafetyDataSelect);
Vue.component('safety-meeting-list', SafetyMeetingList);
Vue.component('safety-settings-list', SafetySettingsList);
Vue.component('saved-filter-title', SavedFilterTitle);
Vue.component('specific-body-parts-list', SpecificBodyPartsList);
Vue.component('status-history', StatusHistory);
Vue.component('sub-approvals-list', SubApprovalsList);
Vue.component('sub-designation-modal', SubDesignationModal);
Vue.component('sub-designation-create-modal', SubDesignationCreateModal);
Vue.component('sub-designation-list', SubDesignationList);
Vue.component('sub-osha-years-list', SubOshaYearList);
Vue.component('sub-rating-list', SubRatingList);
Vue.component('sub-rating-form', SubRatingForm);
Vue.component('sub-status-modal', SubStatusModal);
Vue.component('sub-section-status-modal', SubSectionStatusModal);
Vue.component('subcontractor-approval-modal', SubApprovalModal);
Vue.component('subcontractor-list', SubcontractorList);
Vue.component('subcontractor-modal', SubcontractorModal);
Vue.component('subcontractor-select', SubcontractorSelect);
Vue.component('table-filters', TableFilters);
Vue.component('table-filters-2', TableFiltersV2);
Vue.component('user-list', UserList);
Vue.component('user-modal', UserModal);
Vue.component('user-name', UserName);
Vue.component('user-select', UserSelect);
Vue.component('user-filters', UserFilters);
Vue.component('vue-headful', vueHeadful);
Vue.component('v-select', vSelect);
Vue.component('vue2-dropzone', vue2Dropzone);
Vue.component('vue-editor', VueEditor);
Vue.component('vue-cropper', VueCropper);
Vue.component('VueRecaptcha', VueRecaptcha);
Vue.component('field-training-list', FieldTrainingList);
Vue.component('trade-list', TradeList);
Vue.component('training-course-list', TrainingCourseList);
Vue.component('work-area-list', WorkAreaList);
Vue.component('registration-list', RegistrationList);
Vue.component('osha-sub-list', OshaSubList);

// Vue.use(vueHeadful, {
//   // key: 'myMetaTags', // custom key for component option (optional)
//   component: true
// });

//Use various components
Vue.use(BootstrapVue);
Vue.use(uiv);
Vue.use(datePicker);
Vue.use(HighchartsVue);
Vue.use(VueSignaturePad);
//Vue.use(VuejsClipper);

loadExporting(Highcharts);
highchartsMore(Highcharts);
loadSolidGauge(Highcharts);
Vue.use(HighchartsVue, { Highcharts });

//MOMENT
moment.tz.setDefault("UTC"); //This needs to be set to the database storage timestamp
Vue.use(VueMoment, {moment});

Vue.use(ServerTable, {
    columnsDropdown: false,
    debounce: 1000,
    perPage: 100,
    perPageValues: [10, 25, 50, 100, 500],
    requestFunction: function (data) {
        //Use the API class
        return this.$http.get(this.url, data)
        .catch(function (e) {
            this.dispatch('error', e);
        }.bind(this));
    },
    //footerHeadings: true,
    skin: 'table table-striped table-bordered table-condensed table-hover dataTable small',
    sortIcon:{
        is:'fa-sort',
        base:'fa',
        up: 'fa-sort-amount-asc',
        down: 'fa-sort-amount-desc'
    },
    texts:{
        count:"{from} to {to} of {count} "+Vue.prototype.__('general.records')+"|{count} "+Vue.prototype.__('general.records')+"|One "+Vue.prototype.__('general.records'),
        first:'First',
        last:'Last',
        filter:"",
        filterPlaceholder: Vue.prototype.__('general.search') + " " + Vue.prototype.__('general.records'),
        limit:"",
        page: Vue.prototype.__('general.page') + ":",
        noResults:"No "+Vue.prototype.__('general.records')+" Found",
        filterBy:"Filter by {column}",
        loading:'Loading...',
        defaultOption:'Select {column}',
        columns: Vue.prototype.__('general.columns'),
    },
    pagination: {
    	chunk: 4
    },
}, false, customVTTheme, customVTComponents);

Vue.use(ClientTable, {
    columnsDropdown: false,
    debounce: 1000,
    // requestFunction: function (data) {
    //     //Use the API class
    //     return this.$http.get(this.url, data)
    //     .catch(function (e) {
    //         this.dispatch('error', e);
    //     }.bind(this));
    // },
    //footerHeadings: true,
    skin: 'table table-striped table-bordered table-condensed table-hover dataTable small',
    perPage: 25,
    perPageValues: [10, 25, 50, 100, 500],
    sortIcon:{
        is:'fa-sort',
        base:'fa',
        up: 'fa-sort-amount-asc',
        down: 'fa-sort-amount-desc'
    },
    texts:{
        count:"{from} to {to} of {count} "+Vue.prototype.__('general.records')+"|{count} "+Vue.prototype.__('general.records')+"|One "+Vue.prototype.__('general.records'),
        first:'First',
        last:'Last',
        filter:"",
        filterPlaceholder: Vue.prototype.__('general.search') + " " + Vue.prototype.__('general.records'),
        limit:"",
        page: Vue.prototype.__('general.page') + ":",
        noResults:"No "+Vue.prototype.__('general.records')+" Found",
        filterBy:"Filter by {column}",
        loading:'Loading...',
        defaultOption:'Select {column}',
        columns: Vue.prototype.__('general.columns'),
    },
    pagination: {
    	chunk: 4
    },
}, false, customVTTheme, customVTComponents);


//Currency Filter
Vue.filter('currency', function (value) {
    //Check for null
    if(value == null || value == '')
    {
        return '';
    }

    //Parse the float
    var decimal = parseFloat(value);

    //Check the value
    if(decimal === NaN)
    {
        //Stop here
        return value;
    }

    //Create the formatter
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });

    //Send it
    return formatter.format(decimal);
});

//Project Age Filter
Vue.filter('projectAge', function(valueInSeconds){
    //The value is in seconds, we need it in days to 2 decimal places
    var days = (valueInSeconds / 86400).toFixed(2);

    //Send it
    return days;
});

Vue.filter('time', function(databaseTimeValue){
    if (databaseTimeValue == null || databaseTimeValue == '')
    {
        return '';
    }

    //Create the moment
    var time = new Date();

    //Explode the time
    var timeParts = databaseTimeValue.split(':');

    //Set the hours and minutes
    time.setHours(timeParts[0]);

    //Set the minutes
    time.setMinutes(timeParts[1]);

    //return the format
    return moment(time).tz(store.state.user.timezone).format('h:mm a');
});

Vue.filter('unixTimestampToDate', function(timestamp){
    if (timestamp == null || timestamp == '')
    {
        return '';
    }

    //Create the moment
    var date = new Date(timestamp * 1000);

    // Hours part from the timestamp
    var hours = date.getHours();
    // Minutes part from the timestamp
    var minutes = "0" + date.getMinutes();
    // Seconds part from the timestamp
    var seconds = "0" + date.getSeconds();

    // Will display time in 10:30:23 format
    //var formattedTime = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
    var formattedTime = hours + ':' + minutes.substr(-2);

    //Send it
    return date.getDate() + formattedTime;
});

Vue.filter('capitalize', function(value){
    //Send it
    return value.charAt(0).toUpperCase() + value.slice(1);
});

// Global RTL flag
Vue.mixin({
  data: globals
})

new Vue({
    router,
    store: store,
    data() {
        return {
            debug: process.env.MIX_BASE_DEBUG,
            env: process.env.MIX_BASE_ENV,
            meritehs_number: process.env.MIX_MERITEHS_NUMBER,
            text_suspended: process.env.MIX_TEXT_SUSPENDED,
            appUrl: '',
            locales: [],
            helpCenterUrl: process.env.MIX_HELP_CENTER,
            filesDownloadOnly: [],
            customVueEditorToolbar: [
                [{
                    header: [false, 1, 2, 3, 4, 5, 6]
                }],
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [{
                    align: ""
                    }, {
                    align: "center"
                    }, {
                    align: "right"
                    }, {
                    align: "justify"
                }],
                ["blockquote", "code-block"],
                [{
                    list: "ordered"
                    }, {
                    list: "bullet"
                    }, {
                    list: "check"
                }],
                [{
                    indent: "-1"
                }, {
                indent: "+1"
                }], // outdent/indent
                [{
                color: []
                }, {
                background: []
                }], // dropdown with defaults from theme
                ["link"], ["clean"] // remove formatting button
            ],
        }
    },
    methods: {
        //Permission Check
        hasPermission: function(slug){
            //Make sure the state user is loading
            if(this.$store.state.user == null)
            {
                return false;
            }

            //If slug is a string, make it an array
            if(typeof slug == "string")
            {
                slug = [slug];
            }

            //If any of the slugs exist
            var matches = slug.filter(value => -1 !== this.$store.state.user.permissions.indexOf(value));

            //Return it
            return (matches.length > 0);
        },

        hasSubPermission(slug){
            //Check this against the user
            return this.$store.state.user.sub_permissions == slug;
        },

        getAlerts(){
        	//IF there is NO user logged in, do not run this
        	if(!this.$store.state.user)
        	{
        		return;
        	}

            //Get the records
            this.$http.get('/alerts/list?unread=true')
                .then(response => {
                    //Set the data
                    //this.alerts = response.data.data;
                    this.$store.commit('setAlerts', response.data.data);
                });
        },

        encodeGetParams(p){
        	return Object.entries(p).map(kv => kv.map(encodeURIComponent).join("=")).join("&");
        },

        setLocale(lang){
        	//Get the records
        	this.$http.postWeb('/language/'+lang)
        	    .then(response => {
        	    	//Alert?

        	        //Set the data
        	        window.location.reload();
        	    });
        },

        getVisibleCols(columns, headings){
            //Get the Elements
            var headers = document.getElementsByClassName('VueTables__heading');

            //Loop and Build the Value of EACH
            var header_vals = [];

            for (var i = headers.length - 1; i >= 0; i--)
            {
                //Push the Value
                header_vals.push(headers[i].innerHTML);
            }

            //Setup Visible Columns
            var headers_visible = [];

            //Now Compare the Option Heading to the values
            for (var i = columns.length - 1; i >= 0; i--)
            {
                //Check if the Key is in the value
                if(headings[columns[i]] && header_vals.indexOf(headings[columns[i]]) !== -1)
                {
                    //Column it visible
                    headers_visible.push(columns[i]);
                }
            }

            //Send it
            return headers_visible;
        },

        getVisibleColumnsFromState(tableName){
            //Get the Statue
            var state = localStorage.getItem('vuetables_'+tableName, null);

            //Parse the State
            if(state)
            {
                //Setup
                state = JSON.parse(state);

                //Show the Columns
                if(state.userColumnsDisplay)
                {
                   	//Get the Visible Columns
                    return state.userColumnsDisplay;
                }
            }

            //Send it
            return false;
        },

        getRowCellClass(cellCount){
            //SEtup
            var grid = 1;

            //Handle Count
            switch(cellCount)
            {
                case 1:
                    grid = 12;
                    break;
                case 2:
                    grid = 6;
                    break;
                case 3:
                    grid = 4;
                    break;
                case 4:
                    grid = 3;
                    break;
                case 5:
                    grid = 2;
                    break;
                case 6:
                    grid = 2;
                    break;
            }

            //send it
            return 'col-md-'+grid;
        },

        getPrettyAssetName(asset_type){
            //Start
            let label = "";

            //Custom Stuff
            switch(asset_type)
            {
                case 'CovidFormEntry':
                    //SEt it
                    label = 'Custom Form';
                    break;

                case 'EmployeeTrainingCourse':
                    //Set it
                    label = 'Training Course';
                    break;

                default:
                    //Setup
                    const camelCase = asset_type.replace(/([a-z])([A-Z])/g, '$1 $2').split(" ");

                    camelCase.forEach(word=>{
                        label = label + word.charAt(0).toUpperCase() + word.slice(1) + " "
                    });
                    break;
            }

            //SEnd it
            return label.trim();
        },

        downloadOnly(ext){
            //SEnd it
            return this.$root.filesDownloadOnly.indexOf(ext) === -1 ? false : true;
        },

        isDateOverdue(date, add_days = null){
        	//Check for empty or null
        	if(date === null || date === '')
        	{
        		return false;
        	}

        	//Setup
        	var date = moment(date);
        	var now = moment();

        	//Check for Add Days
        	if(add_days)
        	{
        		date.add(add_days, 'days');
        	}

        	//Send it
        	return now.diff(date, 'days') >= 0;
        },

        //Get the thumbnail preview
        getThumbnail(file){
            //Check if thumbnail was set on the backend
            if(file.thumbnail)
            {
                return file.thumbnail;
            }

            //Setup
            var preview = null;

            //Switch
            switch(file.file_extension.toLowerCase())
            {
                case 'pdf':
                    preview = '/Images/file-type-pdf_256x256.png';
                    break;
                case 'docx':
                case 'doc':
                    preview = '/Images/file-type-docx_256x256.png';
                    break;
                case 'xls':
                case 'xlsx':
                    preview = '/Images/file-type-xlsx_256x256.png';
                    break;
                case 'mp4':
                case 'avi':
                case 'mov':
                case 'mpg':
                case 'mpeg':
                case 'flv':
                case 'webm':
                case 'mkv':
                case 'ogv':
                case 'wmv':
                    preview = '/Images/file-type-video_256x256.png';
                    break;
                default:
                    //Data should be a path, not a string - we converted those
                    // $path = $this->{$imageDataName};
                    // $type = pathinfo($path, PATHINFO_EXTENSION);
                    // $data = Storage::get($path);
                    // $preview = "data:image/".$type.";base64," . base64_encode($data);
                    this.$root.loadThumbnail(file);

                    //Stop here
                    return '';
                    break;
            }

            //Stop here
            return preview;

            //Set the preview
            //this.$refs['file-' + file.file_id][0].src = preview;
        },

        loadThumbnail(file){
            //Send it
            this.$http.get('files/view/'+file.file_id, {display_type: 'fluid', thumbnail: true})
                .then(response => {
                    //Sent the ref
                    this.$refs['file-' + file.file_id][0].src = response.data;
                })
                .catch(err => {
                    switch(err.status)
                    {
                        case 410:
                            //Stop here?
                            //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                            break;
                    }
                });
        },

        canEditFile(file){
            //ONLY allow editing images
            var imageExts = ['jpeg', 'jpg', 'png', 'gif', 'tiff'];

            //Check it
            if(imageExts.indexOf(file.file_extension.toLowerCase()) !== -1)
            {
                return true;
            }

            return false;
        },
    },
    mounted(){
        //Set Some Root Variables
        this.appUrl = window['appUrl'];
        this.filesDownloadOnly = window['filesDownloadOnly'];
        this.locales = window['locales'];

        //Set user from window variable
        this.$store.commit('login', window['appUser']);

        //Set the token passed in on the blade
        localStorage.setItem('app_token', window['appToken']);

        //Set the falg
        this.$store.commit('appLoading');
    },
    render: h => h(App)
}).$mount('#app')
